import React, {Component} from "react";
import pkg from '../../../package.json'

class Property extends Component{
	constructor(props){
		super(props);
		this.properties = props.properties;
	}

	render(){
	    return (
	      <div> 
	      	{ this.properties.map(elem => {
	      		return (<div>
	      			<h3>{elem.name}</h3>
		      		{elem.value}
		      	</div>)
	      	})}
	      </div>
	    )
	  }
}

export default Property;


// WEBPACK FOOTER //
// ./src/components/About/index.jsx